import React from "react"
import PropTypes from "prop-types"
import P from "../typography/p"

const PersonDetails = ({ age, gender, country, pronouns }) => (
  <P size="small" marginless inline variant="content">
    {[gender, pronouns, country, age].filter(Boolean).map((item, index, array) => (
      <span key={index}>
        {item}
        {index < array.length - 1 && <span> • </span>}
      </span>
    ))}
  </P>
)

PersonDetails.propTypes = {
  age: PropTypes.string,
  gender: PropTypes.string,
  country: PropTypes.string,
  pronouns: PropTypes.string
}

PersonDetails.defaultProps = {
  age: "",
  gender: "",
  country: "",
  pronouns: ""
}

export default PersonDetails
